import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Master";
import getToken from "app/api/getToken";
import { IMaster } from "app/api/types/Masters";

export const GET_MASTERS_REQUEST = "GET_MASTERS_REQUEST";
export const GET_MASTERS_SUCCESS = "GET_MASTERS_SUCCESS";
export const GET_MASTERS_FAIL = "GET_MASTERS_FAIL";

export const getMasters = () => (dispatch: any): any => {
  dispatch({ type: GET_MASTERS_REQUEST });

  const token = getToken();

  return api
    .getMasters(token)
    .then((response: AxiosResponse) => {
      const masterList: IMaster[] = get(response, "data", {});
      dispatch({ type: GET_MASTERS_SUCCESS, payload: masterList });

      return masterList;
    })
    .catch(err => {
      dispatch({
        type: GET_MASTERS_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
